import React, { useState } from "react";
import "./Career.css";

const roles = [
  {
    role: "Executive - Business Support",
    type: "Full-time",
    preferred: "Male or Female",
    experience: "0–2 years",
    background:
      "Candidates with Commerce / Accounting background are preferred (for better understanding of financial documents).",
    skills: `Good communication skills & hands on MS Office.
Ability to solve issues independently.
Ability to handle inbound & outbound leads.
Understanding of loan process.
Ability to maintain records/CRM updates.
Strong follow-up and coordination skills.`,
    responsibilities: `Engage with inbound and outbound Loan leads.
Explain loan products to Customers clearly.
Collect customer details and required documents.
Guide clients throughout the loan application journey.
Follow up regularly to increase lead conversions.
Update CRM/lead management system accurately.
Coordinate with internal team and partner banks/NBFCs.
Ensure smooth and timely processing of each lead.`,
  },
];

const CareerPage = () => {
  const [form, setForm] = useState({
    name: "",
    number: "",
    role: "",
    currentSalary: "",
    expectedSalary: "",
    resume: null,
  });
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (name === "resume") {
      setForm({ ...form, resume: files[0] });
    } else {
      setForm({ ...form, [name]: value });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const formData = new FormData();
    formData.append("name", form.name);
    formData.append("number", form.number);
    formData.append("role", form.role);
    formData.append("currentSalary", form.currentSalary);
    formData.append("expectedSalary", form.expectedSalary);
    if (form.resume) formData.append("resume", form.resume);

    try {
      const res = await fetch("https://core-bankers-backend.vercel.app/apply-job", {
        method: "POST",
        body: formData,
      });

      const data = await res.json();
      if (!res.ok) throw new Error(data.message || "Submission failed");
      setSubmitted(true);
    } catch (err) {
      alert("Error: " + err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="career-page">
      <section className="career-hero">
        <div className="career-hero-inner">
          <span className="cb-section-label">Careers</span>
          <h1>Join Core Bankers</h1>
          <p>
            We’re hiring people who want to help customers access the right loan partners with clarity and care.
          </p>
        </div>
      </section>

      <div className="career-body">
        <h2>Open position</h2>
        <div className="roles">
          {roles.map((job) => (
            <article key={job.role} className="role-card">
              <h3>{job.role}</h3>
              <p>
                <strong>Type:</strong> {job.type}
              </p>
              <p>
                <strong>Preferred:</strong> {job.preferred}
              </p>
              <p>
                <strong>Experience:</strong> {job.experience}
              </p>
              <p>
                <strong>Preferred background:</strong> {job.background}
              </p>
              <p>
                <strong>Skills required:</strong>
              </p>
              <pre className="role-pre">{job.skills}</pre>
              <p>
                <strong>Responsibilities:</strong>
              </p>
              <pre className="role-pre">{job.responsibilities}</pre>
            </article>
          ))}
        </div>

        <h2>Apply for a role</h2>
        {submitted ? (
          <p className="success">Thank you. Your application has been received.</p>
        ) : (
          <form className="career-form" onSubmit={handleSubmit} encType="multipart/form-data">
            <input type="text" name="name" placeholder="Your Name" value={form.name} onChange={handleChange} required />
            <input
              type="text"
              name="number"
              placeholder="Mobile Number"
              value={form.number}
              onChange={handleChange}
              required
            />
            <select name="role" value={form.role} onChange={handleChange} required>
              <option value="">Select Role</option>
              {roles.map((r) => (
                <option key={r.role} value={r.role}>
                  {r.role}
                </option>
              ))}
            </select>
            <input
              type="text"
              name="currentSalary"
              placeholder="Current Salary (if applicable)"
              value={form.currentSalary}
              onChange={handleChange}
            />
            <input
              type="text"
              name="expectedSalary"
              placeholder="Expected Salary"
              value={form.expectedSalary}
              onChange={handleChange}
            />
            <input type="file" name="resume" accept=".pdf,.doc,.docx" onChange={handleChange} required />
            <button type="submit" disabled={loading}>
              {loading ? "Submitting..." : "Submit Application"}
            </button>
          </form>
        )}
      </div>
    </main>
  );
};

export default CareerPage;
